import HeaderHero from "../Contact/HeaderHero";
import ServiceMaintenance from "./ServiceMaintenance";
import Message from '../Message';
import ServiceFeatures from "./ServiceFeatures";
import ServiceMaterial from "./ServiceMaterial";
import { useEffect } from "react";
import ServicesContent from "./ServicesContent";
function Services() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <HeaderHero Name={'Services'} />
            <ServicesContent />
            <ServiceFeatures />
            <ServiceMaterial />
            <ServiceMaintenance />
            <Message />
        </>
    )
}
export default Services;